import { Card, Divider, Spin } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import OrderService from "../../../../services/OrderService";
import { OrderSummary } from "../../../../models/Order";
import OrderTable from "./OrderTable";
import OrderControl from "./OrderControl";

const Orders: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState<OrderSummary[]>([]);
  const [clientFilter, setClientFilter] = useState<string>("");
  const [orderNumberFilter, setOrderNumberFilter] = useState<string>("");
  const [startDateFilter, setStartDateFilter] = useState<string>("");
  const [endDateFilter, setEndDateFilter] = useState<string>("");
  const [ordersCount, setOrdersCount] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [page, setPage] = useState<number>(1);

  const fetchOrders = useCallback(
    (
      page: number,
      pageSize: number,
      client = clientFilter,
      orderNumber = orderNumberFilter,
      startDate = startDateFilter,
      endDate = endDateFilter,
    ) => {
      setLoading(true);
      OrderService.getAll(
        page,
        pageSize,
        client,
        orderNumber,
        startDate,
        endDate,
      ).then((response) => {
        if (!response) return;
        setOrders([...response.data].reverse());
        setOrdersCount(response.total);
        setLoading(false);
      });
    },
    [clientFilter, orderNumberFilter, startDateFilter, endDateFilter],
  );

  const onPageChange = useCallback(
    (page: number, pageSize: number) => {
      setPage(page);
      setPageSize(pageSize);
      fetchOrders(page, pageSize);
    },
    [fetchOrders],
  );

  const onApply = useCallback(
    (
      client: string,
      orderNumber: string,
      startDate: string,
      endDate: string,
    ) => {
      setClientFilter(client);
      setOrderNumberFilter(orderNumber);
      setStartDateFilter(startDate);
      setEndDateFilter(endDate);
      setPage(1);
      fetchOrders(1, pageSize, client, orderNumber, startDate, endDate);
    },
    [pageSize, fetchOrders],
  );

  useEffect(() => {
    fetchOrders(page, pageSize);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Spin spinning={loading}>
        <Card
          title={"Orders"}
          style={{
            margin: "20px",
            padding: "20px",
          }}
        >
          <OrderControl onApply={onApply} />
          <Divider />
          <OrderTable
            orders={orders}
            pageSize={pageSize}
            onPageChange={onPageChange}
            OrderCount={ordersCount}
          />
        </Card>
      </Spin>
    </>
  );
};

export default Orders;
